/**
 * Asynchronously loads the component for MyautoiqCampaignsLeadsDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const MyautoiqCampaignsLeadsDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.MyautoiqCampaignsLeadsDetailsPage,
);
